import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { InviteOption } from "../../models/InternalUser";
import AppText from "../Core/AppText/AppText";
import Checkbox from "../Core/Checkbox/Checkbox";
import Button from "../Core/Button/Button";

interface InvitationPopMenuProps {
	title: string;
	text: string;
	acceptButtonText: string;
	rejectButtonText: string;
	onReject: any;
	onAccept: any;
	email?: string;
	phoneNo?: string;
}

const InvitationModal = ({
	title,
	text,
	rejectButtonText,
	acceptButtonText,
	onAccept,
	onReject,
	email,
	phoneNo,
}: InvitationPopMenuProps) => {
	const { t } = useTranslation();
	const [inviteType, setInviteType] = useState<InviteOption>({
		mail: true,
		sms: true,
	});
	return (
		<ModalContainer>
			<ModalWrapper>
				<AppText size="xm" weight="bold">
					{title && t(title as any)}
				</AppText>
				<AppText margin="1.5rem 0 2rem 0" textAlign="center">
					{text && t(text as any)}
				</AppText>
				<div style={{ alignItems: "left" }}>
					<Checkbox
						label={t("customer.user.inviteModal.emailLabel", { email: email || "" })}
						isChecked={inviteType.mail}
						margin="0 0 15px 0"
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							if (e.target.checked) {
								setInviteType((inviteType) => ({ ...inviteType, mail: true }));
							} else {
								setInviteType((inviteType) => ({ ...inviteType, mail: false }));
							}
						}}
					/>
					<Checkbox
						label={t("customer.user.inviteModal.smsLabel", {
							phoneNo: phoneNo || "",
						})}
						isChecked={inviteType.sms}
						margin="0 0 15px 0"
						onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
							if (e.target.checked) {
								setInviteType((inviteType) => ({ ...inviteType, sms: true }));
							} else {
								setInviteType((inviteType) => ({ ...inviteType, sms: false }));
							}
						}}
					/>
				</div>
				<Button
					width="12.625rem"
					backgroundColor="primary"
					textColor="white"
					margin="0 0 0.5rem 0"
					onClick={() => onAccept(inviteType)}
				>
					{t(acceptButtonText as any)}
				</Button>
				<Button
					width="12.625rem"
					backgroundColor="dividerGray"
					textColor="black"
					onClick={() => onReject()}
				>
					{t(rejectButtonText as any)}
				</Button>
			</ModalWrapper>
		</ModalContainer>
	);
};

export default InvitationModal;

const ModalContainer = styled.div`
	position: fixed;
	z-index: 1000;
	top: 0;
	left: 0;
	width: 100%;
	height: 100%;
	display: flex;
	align-items: center;
	background: rgba(0, 0, 0, 0.6);
	overflow-y: auto;
`;

const ModalWrapper = styled.section`
	background: white;
	width: 100%;
	max-width: 32.5rem;
	margin: 10em auto 5em auto;
	height: auto;
	align-items: center;
	border-radius: 10px;
	display: flex;
	flex-direction: column;
	padding: 3.125rem;
`;
